<template>
  <div class="box">
    <div class="tab-content">
      <el-form
        ref="form"
        :label-position="'left'"
        :rules="rules"
        :model="form"
        label-width="100px"
      >
        <el-form-item label="报告组:" prop="ground">
          <el-select
            size="medium"
            v-model="form.ground"
            placeholder="选择报告组"
            @change="groundchange"
          >
            <el-option
              v-for="item in allground"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模型:" prop="modelname">
          <el-select
            size="medium"
            v-model="form.modelname"
            placeholder="选择模型"
            @change="modelchange"
          >
            <el-option label="节能空间分析报告" value="2"></el-option>
            <el-option label="用能成本分析报告" value="3"></el-option>
            <el-option label="用能体检分析报告" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模型配置:" prop="modelvalue">
          <el-select
            size="medium"
            v-model="form.modelvalue"
            placeholder="先选择模型再选择模型配置"
          >
            <el-option
              v-for="item in modle"
              :key="item.id"
              :label="item.baseName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期:" prop="startdate">
          <el-date-picker
            size="medium"
            v-model="form.startdate"
            type="date"
            align="right"
            unlink-panels
            placeholder="选择日期"
            value-format="yyyy/MM/dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="结束时间:" prop="enddate">
          <el-date-picker
            size="medium"
            v-model="form.enddate"
            type="date"
            align="right"
            unlink-panels
            placeholder="选择日期"
            value-format="yyyy/MM/dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="subdata">生成报告</el-button>
        </el-form-item>
      </el-form>
    </div>

    <template v-if="!isDoing">
      <div class="pdf-content" v-if="startId == '1' ? true : false">
        <economize
          :data="data"
          :show="true"
          :downLoadName="downLoadName"
        ></economize>
      </div>
      <div class="pdf-content" v-if="startId == '2' ? true : false">
        <energycost
          :data="data"
          :show="true"
          :downLoadName="downLoadName"
        ></energycost>
      </div>
      <div class="pdf-content" v-if="startId == '3' ? true : false">
        <examination
          :data="data"
          :show="true"
          :downLoadName="downLoadName"
        ></examination>
      </div>
  </template>
  </div>
</template>

<script>
import economize from "./bg/economize.vue";
import energycost from "./bg/energycost.vue";
import examination from "./bg/examination.vue";
export default {
  components: { economize, energycost, examination },
  data() {
    return {
      rules: {
        ground: [
          {
            required: true,
            message: "请选择报告组",
            trigger: ["blur", "change"],
          },
        ],
        modelname: [
          {
            required: true,
            message: "请选择模型",
            trigger: ["blur", "change"],
          },
        ],
        modelvalue: [
          {
            required: true,
            message: "请选择模型配置",
            trigger: ["blur", "change"],
          },
        ],
        startdate: [
          {
            required: true,
            message: "请选择日期",
            trigger: ["blur", "change"],
          },
        ],
        enddate: [
          {
            required: true,
            message: "请选择结束日期",
            trigger: ["blur", "change"],
          },
        ],
      },
      form: {
        ground: "",
        modelname: "",
        modelvalue: "",
        startdate: "",
        enddate: "",
      },

      allground: [],
      modle: [],
      activeName: "2",
      download: [],
      startId: null,
      data: null,
      downLoadName: "",
      btn: "",
      bgdata: null,
      isDoing: false
    };
  },
  created() {
    this.$api.nhtj.getReportGroups("0").then((res) => {
      this.allground = res.data;
      // this.$api.nhtj.listReport("0", [res.data[0].id]).then(res => {
      //   console.log(res);
      //   // this.startId = "1";
      //   this.download = res.data;
      //   console.log(res.data[0].id);
      //   // this.clickdownload(res.data[0], 0);
      // });
    });
  },
  mounted() {
    // this.download = ["节能空间分析报告.pdf"];
    // this.startId = "1";
  },
  methods: {
    groundchange(e) {
      // this.$api.nhtj.getReportAutomaticGeneratingConfigs(0, [e]).then(res => {
      //   console.log(res);
      //   this.bgdata = res.data;
      // });
    },
    modelchange(e) {
      this.form.modelvalue = "";
      this.$api.nhtj
        .getConfigsByModelAndGroup(this.form.modelname, this.form.ground)
        .then((res) => {
          console.log(res);
          this.modle = res.data;
        });
    },
    subdata() {
      let vm = this;
      vm.$refs["form"].validate((valid) => {
        if (valid) {
          if (vm.isDoing) {
            return
          }
          this.isDoing = true
          this.$api.nhtj
            .testReportByConfig(
              this.modle[0].model,
              this.modle[0].baseName,
              this.modle[0].params,
              this.modle[0].loopRegulation,
              this.form.startdate,
            )
            .then((res) => {
              this.isDoing = false
              if (vm.form.modelname == "2") {
                vm.startId = "1";
                vm.data = res.data;
                vm.downLoadName = "节能空间分析报告";
              } else if (vm.form.modelname == "3") {
                vm.startId = "2";
                vm.data = res.data;
                vm.downLoadName = "用能成本分析报告";
              } else if (vm.form.modelname == "4") {
                vm.startId = "3";
                vm.data = res.data;
                vm.downLoadName = "用能体检分析报告";
              }
            });
        } else {
          this.isDoing = false
          return false;
        }
      });
    },
  },
};
</script>
<style scoped>
.tab-content >>> .el-input {
  max-width: 100%;
}
</style>
<style lang="scss" scoped>
::v-deep .el-form-item__error {
  line-height: 0;
  padding-top: 10px;
  left: -30px;
}
.box {
  padding: 20px 0px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
}
.tab-content {
  flex: 0 0 300px;
  border-right: 1px solid #e4e7ed;
  padding-right: 10px;
  margin-left: 10px;
}

.pdf-content {
  flex: 1;
  padding: 0px 20px;
  text-align: left;
}
.list-content {
  flex: -1 0 300px;
  border-right: 2px solid #e4e7ed;
}
.tabdownload {
  display: flex;
  -ms-flex-pack: distribute;
  justify-content: space-around;
  // border-bottom: 1px solid #e4e7ed;
  padding: 10px;
}
.btn {
  flex: 1;
  display: block;
  cursor: pointer;
}
.btnclick {
  flex: 1;
  display: block;
  cursor: pointer;
  color: #409eff;
  border-bottom: 2px solid #409eff;
  height: 40px;
}
.btn-download:hover {
  cursor: pointer;
  color: #409eff;
}
</style>
<style lang="scss">
.box {
  .tabs {
    .el-tabs__item {
      height: 100px !important;
    }
  }
  .layou-container {
    white-space: break-spaces;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
